

// You can separate your code out into modules to
// keep code clean.

class MyClass {
  constructor() {

  }

  sayHi() {
    console.log('[MyClass]', 'Hello World.');
  }
}

module.exports = MyClass;